module.exports = __webpack_public_path__ + "img/dsci0084.2456b4ef.jpg";